import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    data: {
        payload: null
    }
};


export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state,data) => {
        state.data = data;
    }
}
})

export const { setUser } = userSlice.actions;

export default userSlice.reducer;